<div class="role-switcher-container">
  <ng-container *ngIf="stores.length > 1">
    <sv-dropdown
      class="dropdown-selectbox"
      [(ngModel)]="selectedStore"
      [items]="stores"
      bindLabel="label"
      bindValue="value"
      [clearable]="false"
      [searchable]="false"
      [hideSelected]="true"
      (change)="changeRole()"
    >
      <ng-template svDropdownLabel let-item="item">
        <button class="btn btn-clean btn--iconMuted">
          <span class="c-btn__title">{{ item.label }}</span>
        </button>
      </ng-template>
    </sv-dropdown>
  </ng-container>
  <ng-container *ngIf="stores.length == 1">
    <span>{{ (authUser$ | async)?.store.label }}</span>
  </ng-container>
</div>

<sv-spinner-loader
  [loading]="loading"
  [fullScreenBackdrop]="true"
></sv-spinner-loader>
